import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AdminUserService } from '../../app/user/service';
import authSlice from '../../store/slices/auth.slice';
import { RootState } from '../../store/store';
import i18n, { resources } from '../../utils/localization/i18n';
import { handleError } from '../functions/handleError';
import { IUser } from '../interfaces/IUser';

const Header = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { firstName, language, id } = useSelector(
    (state: RootState) => state.auth.userData,
  ) as IUser;
  const handleChangeLanguage = async (language: string) => {
    const formData = new FormData();
    formData.append('body', JSON.stringify({ language }));
    !!id &&
      (await AdminUserService.update(formData, Number(id))
        .then(async (response) => {
          if (response) {
            dispatch(
              authSlice.actions.setLoginState({
                isAuthenticated: true,
                userData: response,
              }),
            );
            await i18n.changeLanguage(language);
          }
        })
        .catch(handleError));
  };
  return (
    <Card className={'position-sticky top-10px mb-3 z-1'}>
      <Card.Body style={{ padding: '10px 20px' }}>
        <header className={'d-flex align-items-center justify-content-between'}>
          <h6>
            {t('general.welcomeBack')}, {firstName}
          </h6>
          <div className="d-flex align-items-center">
            <img
              src={`https://flaglog.com/codes/standardized-rectangle-120px/${language?.toUpperCase()}.png`}
              alt={`${language} flag`}
              className={'country-flag-header me-2'}
            />
            <select
              className={'form-select me-2'}
              onChange={(e) => handleChangeLanguage(e.target.value)}
              value={language}
            >
              {Object.keys(resources)?.map((lng) => {
                return (
                  <option value={lng} key={lng}>
                    {t(`language.${lng}`)}
                  </option>
                );
              })}
            </select>
          </div>
        </header>
      </Card.Body>
    </Card>
  );
};

export default Header;
